import { render, staticRenderFns } from "./UserGroupEntry.vue?vue&type=template&id=3f1762ed&scoped=true"
import script from "./UserGroupEntry.vue?vue&type=script&lang=js"
export * from "./UserGroupEntry.vue?vue&type=script&lang=js"
import style0 from "./UserGroupEntry.vue?vue&type=style&index=0&id=3f1762ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1762ed",
  null
  
)

export default component.exports